import { useAuth } from '@/stores/useAuth';
import { useShallow } from 'zustand/react/shallow';

export const useWalletAddress = () => useAuth(useShallow((state) => state.address));
